import { render, staticRenderFns } from "./StepThreeOptimize.vue?vue&type=template&id=21b2a94c&scoped=true"
import script from "./StepThreeOptimize.vue?vue&type=script&lang=js"
export * from "./StepThreeOptimize.vue?vue&type=script&lang=js"
import style0 from "./StepThreeOptimize.vue?vue&type=style&index=0&id=21b2a94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2a94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
